import React from 'react';
import './style.scss';
import {useDispatch} from "react-redux";

// show textTitle prop makes use of HTML text over the images rather than baked in text
const ReportThumbnail = (props) => {
  const {
    report,
    showTextTitle,
    onClickAction
  } = props;

  let className = 'report-thumbnail-link';
  if (showTextTitle) {
    className += ' text-title';
  }

  return (
    <button className={className} onClick={ () => onClickAction()}>
      <div className="report-thumbnail">
        { showTextTitle ? <p className="report-name">{report.title}</p> : null }
        <img src={report.thumbnailUrl} alt={showTextTitle ? "" : report.title} />
      </div>
    </button>
  );
};

let a11yId = 0;

const ReportCollection = (props) => {
  const {
    title,
    reports,
    showTextTitle,
    onClickAction
  } = props;

  return (
    <section className="reports-section" aria-labelledby={`report-${++a11yId}`}>
      <h2 id={`report-${a11yId}`}>{title}</h2>
      <ul className="reports-row">
        {reports.map(report => (
          <li key={report.id}>
            <ReportThumbnail report={report} showTextTitle={showTextTitle} onClickAction={() => onClickAction(report)}/>
          </li>
        ))}
      </ul>
    </section>
  );
}

export default ReportCollection;
